module.exports = __webpack_public_path__ + "img/selected3-min.ec5a43f9.png";